package com.eladfinish.bible.contest.usecase

import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfig
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfigRepository
import com.eladfinish.bible.contest.repository.remoteConfig.get
import com.eladfinish.bible.contest.usecase.remoteConfig.GetRemoteConfigValueProvider
import kotlin.reflect.KClass

class GetRemoteConfigValueUseCase(
    val remoteConfigRepository: RemoteConfigRepository,
) : GetRemoteConfigValueProvider {

    override fun <T : Any> invoke(remoteConfig: RemoteConfig, clazz: KClass<T>): T? {
        return remoteConfigRepository.get(remoteConfig, clazz)
    }

    inline operator fun <reified T : Any> invoke(remoteConfig: RemoteConfig): T? =
        remoteConfigRepository.get<T>(remoteConfig)

    inline infix operator fun <reified T : Any> get(remoteConfig: RemoteConfig): T? =
        remoteConfigRepository.get(remoteConfig)

    inline fun <reified T : Any> getOrDefault(
        remoteConfig: RemoteConfig,
        default: T,
    ): T = get(remoteConfig) ?: default

    inline fun <reified T : Any> getOrDefault(
        remoteConfig: RemoteConfig,
        block: () -> T,
    ): T = get(remoteConfig) ?: block()
}
